import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { SharedLanguageService } from '@language';
import { SharingWrapperContainerComponent } from '../containers/sharing-wrapper/sharing-wrapper.container.component';
import { sessionStorageHelper } from '@stylehaven/components';

export const sharingLeaveGuard: CanDeactivateFn<SharingWrapperContainerComponent> = (
    component: SharingWrapperContainerComponent,
    currentRoute,
    currentState,
    nextState
): Observable<boolean> | Promise<boolean> | boolean => {
    if (component.isNavigatingAway) {
        return true;
    }

    const languageService: SharedLanguageService = inject(SharedLanguageService);

    // Check if we're staying within the same share context
    const currentUrl = currentState?.url || '';
    const nextUrl = nextState?.url || '';

    // Extract shareId from both URLs
    const shareIdMatch: RegExpMatchArray | null = /\/shared\/([^\/]+)/.exec(currentUrl);
    const nextShareIdMatch: RegExpMatchArray | null = /\/shared\/([^\/]+)/.exec(nextUrl);

    const currentShareId: string | undefined = shareIdMatch?.[1];
    const nextShareId: string | undefined = nextShareIdMatch?.[1];

    // If staying within the same share, allow navigation without prompt
    if (currentShareId && nextShareId && currentShareId === nextShareId) {
        return true;
    }

    const navigateAway: boolean = confirm(languageService.translate('sharing.context-leave-warning'));

    if (!navigateAway) {
        return false;
    }

    sessionStorageHelper.remove('shareToken');
    sessionStorageHelper.remove('shareId');
    component.setNavigatingAway();

    return true;
};
